import { axiosInstance } from '@/lib/axios'
import { PaginatedVehiclesResponse, VehiclesResponse } from '../vehicle-list/types'

type Props = {
  companyId: string
  page?: number
  pageSize?: number
  groupId?: number
  isActive?: boolean
  search?: string
}

export function getVehiclesWithLocksList({ companyId, page, pageSize, groupId, isActive, search }: Props) {
  const params = new URLSearchParams()

  if (page !== undefined) params.append('page', page.toString())
  if (pageSize !== undefined) params.append('pageSize', pageSize.toString())
  if (groupId !== undefined) params.append('groupId', groupId.toString())
  if (isActive !== undefined) params.append('isActive', isActive.toString())
  if (search !== undefined && search.trim() !== '') params.append('search', search.trim())

  const queryString = params.toString()
  const url = `/api/${companyId}/vehicle/vehiclesWithLocks${queryString ? `?${queryString}` : ''}`
  const isPaginated = page !== undefined || pageSize !== undefined

  if (isPaginated) {
    return axiosInstance.get<PaginatedVehiclesResponse>(url)
  }

  return axiosInstance.get<VehiclesResponse>(url)
}
